import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import FormFieldCandidate from "../components/form/FormFieldCandidate";
import { signIn, clearError } from "../actions";

class LoginForm extends Component {
  // state = {
  //   errors: false,
  // };

  componentDidMount() {
    localStorage.setItem('request', JSON.stringify({}));
    localStorage.setItem('totalAttempted', 0);
  }
  abortController = new AbortController()

  componentWillUnmount() {
    this.abortController.abort()
  }


  onFormSubmit = (formValues) => {
    this.props.signIn(formValues);
  };

  render() {
    return (
      // <!-- Outer Row -->
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              {/* <!-- Nested Row within Card Body --> */}
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block d-flex align-items-center justify-content-center">
                  <img src="/neco.png" alt="NECO Logo" className="img-fluid" style={{maxHeight: '400px', width: 'auto'}} />
                </div>
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <h1 className="h4 text-gray-900 mb-4">Welcome!</h1>
                      {/* {!this.state.errors ? (
                        <h1 className="h4 text-gray-900 mb-4">Welcome!</h1>
                      ) : (
                        <div className="alert alert-danger" role="alert">
                          {this.state.errors.errors[0].message}
                        </div>
                      )} */}
                    </div>
                    <form
                      onSubmit={this.props.handleSubmit(this.onFormSubmit)}
                      className="user"
                    >
                      <Field
                        component={FormFieldCandidate}
                        type="text"
                        label="Registration Number"
                        name="registrationNumber"
                      />
                      <button
                        disabled={this.props.isLoading}
                        className="btn btn-success btn-user btn-block"
                      >
                        {this.props.isLoading ? 'Processing...' : 'Login'}
                        <i className="ml-2 fas fa-sign-in-alt"></i>
                      </button>
                    </form>
                    <hr />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function validate(formValues) {
  const errors = {};

  // check if field is empty
  if (!formValues.registrationNumber) {
    errors.registrationNumber = "Please enter your Registration Number";
  }
  if (
    formValues.registrationNumber &&
    formValues.registrationNumber.length < 3
  ) {
    errors.registrationNumber = "Please enter a valid Registration Number";
  }

  return errors;
}

const mapStateToProps = state => {
    return {
      isSignedIn: state.auth.isSignedIn, 
      isLoading: state.utils.loading
    }
};

const formWrapped = reduxForm({
  validate,
  // destroyOnUnmount: false,
  form: "loginFormCandidate",
})(LoginForm);

export default connect(mapStateToProps, { signIn, clearError })(formWrapped);
